module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mdl-grid adv-content",
    attrs: {
      "id": "page-about"
    }
  }, [_c('div', {
    staticClass: "adv-help mdl-card mdl-shadow--2dp mdl-cell\n                mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--8-col-desktop"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-color-text--grey-600"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('p', [_vm._v("Adventify is a graphic adventure gaming platform where you can play and create your own games.")]), _vm._v(" "), _c('p', [_vm._v("Here's a quick tutorial to create an easy game:")]), _vm._v(" "), _c('p', {
    staticClass: "mdl-cell--hide-phone "
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "420",
      "src": "https://www.youtube.com/embed/OUH2FQaBcnM",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "mdl-cell--hide-tablet mdl-cell--hide-desktop"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "220",
      "src": "https://www.youtube.com/embed/OUH2FQaBcnM",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card_title"
  }, [_c('i', {
    staticClass: "adv-info material-icons"
  }, [_vm._v("info")]), _vm._v("\n          HOW TO MAKE ADVENTURES\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-help mdl-card mdl-shadow--2dp mdl-cell\n                mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--8-col-desktop"
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-card_title"
  }, [_c('i', {
    staticClass: "adv-info material-icons"
  }, [_vm._v("help")]), _vm._v("\n          OTHER QUESTIONS\n          ")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("If you have any questions or comments, please contact our "), _c('br'), _c('br'), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-button--raised",
    attrs: {
      "href": "http://www.twitter.com/adventify"
    }
  }, [_vm._v("twitter account")])]), _c('br')]), _vm._v(" "), _c('p'), _c('h4', [_vm._v(" WHAT'S NEXT?")]), _vm._v(" "), _c('pre', {
    staticStyle: {
      "color": "white",
      "white-space": "pre-wrap"
    }
  }, [_vm._v("\nThis is my current backlog (subject to change randomly):\n\n  - Adventures Search\n  - Object Search\n  - Object selection (search) - both in timeline, compose and inventory\n  - Actions Checkbox for usage reverse order (inventory)\n\n  - Entering coordinates manually: X,y, width, height on compose\n  - Maximize, align, distribute\n  - Resizing top-left limits\n\n  - Batch upload for pictures (if still untitled, take image file name)\n\n  - Multiple result objects\n\n  - Cutscenes:\n    -  Image + Text: reproduce as soon as entering a group:\n        - Set action as finished when finished playing  \n\n  - Drag and drop on mobile\n    \n  Landing page:\n  - Features, video? Logo animation\n  - Wizard - creator link\n  - Intro / tutorial\n\n  - Extra event types:\n    - Dialogs: creation / speech generation\n    - Cutscenes\n\n  - Music\n  - Sound-Effects\n\n  Add payments\n  Pro users?\n  Limit ADV for user normal users\n    \n  - Max files per user?\n  - Flatten database more?: adventures, chapters, stages, ... all on the same level?\n  - Validation for timeline / saves and other current free shape objects\n  - Flatten storage structure?:\n    -  Storage structure: id as upper folder for security...? \n\n  - Genres, age, ratings, comments\n    - Details page before playing?\n  - Graphic editor for stages/objects\n    - Background removal (color/shape)  \n\n  - Characters:\n    - Add a character to scene: \n        - Avatar (for dialogs): face selection\n        - Animator: \n          - Talking\n          - Walking\n\n  - Video (from youtube?)\n  - Text Options\n  - Interface config: colors, sizes, etc\n  - Inventory auto-hide as an option (show on composition)\n            ")]), _vm._v(" "), _c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b54e4602!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionContact.vue
// module id = 318
// module chunks = 0